import { Section } from '../models';
import { EntitySummarySection } from '../services';

export const isSummarySection = (section: Pick<Section, 'sectionId'>) =>
  Object.values(EntitySummarySection).includes(section.sectionId);
